import { render, staticRenderFns } from "./LinkProductModal.vue?vue&type=template&id=4dd55a49&scoped=true"
import script from "./LinkProductModal.vue?vue&type=script&lang=js"
export * from "./LinkProductModal.vue?vue&type=script&lang=js"
import style0 from "./LinkProductModal.vue?vue&type=style&index=0&id=4dd55a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd55a49",
  null
  
)

export default component.exports